import React, { useState } from 'react';
import { Form, Button, Spinner, Alert, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/StockSearch.css';
import config from '../config';

function StockSearch({ setSymbol, setDailyAnalysis, setDailyHistory, setInfo }) {
  const [inputSymbol, setInputSymbol] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async (symbol) => {
    setLoading(true);
    setError('');
    try {
      const analysisResponse = await fetch(`${config.apiUrl}/api/v1/analysis/last-analysis/${symbol}`);
      const historyResponse = await fetch(`${config.apiUrl}/api/v1/data/history/${symbol}`);
      const infoResponse = await fetch(`${config.apiUrl}/api/v1/data/stock/${symbol}`);
      if (!analysisResponse.ok || !historyResponse.ok || !infoResponse.ok) {
        throw new Error('Failed to fetch data');
      }
      const analysisData = await analysisResponse.json();
      const historyData = await historyResponse.json();
      const infoData = await infoResponse.json();
      setDailyAnalysis(analysisData);
      setDailyHistory(historyData);
      setInfo(infoData);
      setSymbol(symbol);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch(inputSymbol);
  };

  return (
    <Form onSubmit={handleSubmit} className="ml-2 search-form">
      <Row>
        <Col xs={8}>
          <Form.Control
            type="text"
            value={inputSymbol}
            onChange={(e) => setInputSymbol(e.target.value)}
            placeholder="e.g. AAPL, TSLA"
            className="ml-sm-2"
            required
          />
        </Col>
        <Col xs={3}>
          <Button variant="outline-light" type="submit" disabled={loading} block>
            {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Search'}
          </Button>
        </Col>
      </Row>
      {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
    </Form>
  );
}

export { StockSearch };